import { render } from "./AuftraegeView.vue?vue&type=template&id=bb9d432e&scoped=true"
import script from "./AuftraegeView.vue?vue&type=script&lang=js"
export * from "./AuftraegeView.vue?vue&type=script&lang=js"

import "./AuftraegeView.vue?vue&type=style&index=0&id=bb9d432e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9d432e"]])

export default __exports__